export const tab_list = ["PURCHASE", "PAYMENT", "JOURNAL", "LOGBOOK", "OTHERS", "REJECT"]